import { createFormHook } from '@tanstack/react-form'
import {
  Select,
  SubscribeButton,
  TextArea,
  TextField,
} from '@/shared/form/demo-form-components'
import { fieldContext, formContext } from '@/shared/form/demo-form-context'

export const { useAppForm } = createFormHook({
  fieldComponents: {
    TextField,
    Select,
    TextArea,
  },
  formComponents: {
    SubscribeButton,
  },
  fieldContext,
  formContext,
})
